import ClientFactory from '@xfinity/maw-fetch';
import { ApiErrorHandler } from '../helpers/errors';
import kibanaServiceLogWrapper from '../helpers/kibanaServiceLogWrapper';

const { basePath } = window.MAW || {};

const onError = ApiErrorHandler();

const client = ClientFactory({
  logger: { log: () => {} },
  kibanaServiceLog: kibanaServiceLogWrapper,
  basePath,
  onError,
});

export default client;
